export enum DateCheck {
    validDates = 'Start and end dates are valid.',
    lessThanToday = 'Start date is less than today.',
    startGreaterThanEnd = 'Start date is greater than end date.',
    endLessThanStart = 'End date is less than start date.'
}